import { render, staticRenderFns } from "./hospitalAssetContract.vue?vue&type=template&id=60e64c45&scoped=true"
import script from "./hospitalAssetContract.vue?vue&type=script&lang=js"
export * from "./hospitalAssetContract.vue?vue&type=script&lang=js"
import style0 from "./hospitalAssetContract.vue?vue&type=style&index=0&id=60e64c45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e64c45",
  null
  
)

export default component.exports